var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 46,
    viewBox: "0 0 53 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.43 39.741l-11.123-18.83L30.186 2.098A4.312 4.312 0 0026.49 0c-1.523 0-2.934.796-3.695 2.08L.57 39.705a4.108 4.108 0 000 4.179A4.267 4.267 0 004.266 46h44.468a4.312 4.312 0 003.695-2.098 4.075 4.075 0 000-4.16zM24.262 14.2c0-1.158.947-2.08 2.135-2.08 1.188 0 2.135.922 2.135 2.08v14.29c0 1.158-.947 2.08-2.135 2.08-1.188 0-2.135-.922-2.135-2.08V14.2zm2.228 24.962c-1.541 0-2.785-1.212-2.785-2.713 0-1.501 1.244-2.713 2.785-2.713 1.54 0 2.785 1.212 2.785 2.713 0 1.502-1.244 2.713-2.785 2.713z",
    fill: "#F72A4F"
  })));
}

export default SvgWarning;